export enum PortfolioTypes {
    managed = 'managed', // managed
    // wine = 'wine', // this is the wine portfolio
    // whiskey = 'whiskey', // falls under managed
    trading = 'trading' // falls under managed
}
